import { render } from "./UpdateRequest.vue?vue&type=template&id=49a13bfa&scoped=true&ts=true"
import script from "./UpdateRequest.vue?vue&type=script&lang=ts"
export * from "./UpdateRequest.vue?vue&type=script&lang=ts"

import "./UpdateRequest.vue?vue&type=style&index=0&id=49a13bfa&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a13bfa"]])

export default __exports__